import { createFileRoute } from "@tanstack/react-router";
import TicaAyer from "@/pages/TicaAyer";
import { loadResultsSummary } from "@/lib/results-seo";

export const Route = createFileRoute("/que-salio-ayer-en-tiempos-jps")({
  loader: ({ context }) => loadResultsSummary(context.queryClient, 1),
  head: ({ loaderData }) => {
    const s = loaderData ?? { dateLabel: "", tica: "", nica: "" };
const title = `¿Qué salió ayer en los Tiempos JPS? ${s.dateLabel}${s.tica ? `: ${s.tica}` : ""} | Tica`;
const description = `Qué salió ayer en los Tiempos JPS (${s.dateLabel}): ${s.tica || "sorteos de 1pm, 4:30pm y 7:30pm"}. Nuevos Tiempos de Costa Rica de ayer, con Bolita Blanca o Reventado.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://tiemposhoy.com/que-salio-ayer-en-tiempos-jps" },
        { name: "twitter:card", content: "summary" },
      ],
      links: [{ rel: "canonical", href: "https://tiemposhoy.com/que-salio-ayer-en-tiempos-jps" }],
    };
  },
  component: TicaAyer,
});
